import { Comparator }	from "ts-base/comparator";

import { Textual }		from "@v3/data/textual";

import { BusinessWeek }	from "@v3/data/time";

// YYYY-'W'WW
export type IsoWeek		= Textual.Value<typeof Base>;

const test	= (s:string):boolean => {
	const rough	= /^\d{4}-W(0[1-9]|[1-4][0-9]|5[0-3])$/.test(s);
	if (!rough)			return false;

	const parts	= s.split("-W");
	const year	= parseInt(parts[0]);
	const week	= parseInt(parts[1]);

	const maxWeek	= BusinessWeek.numberInYear(year);
	if (week > maxWeek)	return false;

	return true;
};

const Base	=
	Textual.predicate(
		"IsoWeek",
		test,
		"must be an iso-8601 calendar week in YYYY-'W'WW format"
	);

namespace Extension {
	export const compare	= Comparator.builtinOf<IsoWeek>();
}

export const IsoWeek	= { ...Extension, ...Base };
